import React from 'react'
import { CalendarLayout, CalendarTitle } from 'ui/calendar/index'
import { Env } from '@morningtrain/helpers'
import * as moment from 'moment'

function CalendarHeader () {
  const weekdays = moment.weekdays(false)

  weekdays.push(weekdays.shift())

  return (
    <CalendarLayout>
      {weekdays.map((weekday) => {
        return (
          <CalendarTitle>
            {weekday}
          </CalendarTitle>
        )
      })}
    </CalendarLayout>
  )
}

export default CalendarHeader
